// src/pages/admin/Clientes.js
import React, { useEffect, useState } from 'react';
import api from '../../utils/api';

export default function Clientes() {
  const [clientes, setClientes] = useState([]);
  const load = () => api.get('/clientes').then(r => setClientes(r.data)).catch(()=>{});
  useEffect(() => { load(); }, []);

  const eliminarCliente = async (id) => {
    if (!window.confirm('Eliminar este cliente?')) return;
    try {
      await api.delete('/clientes/' + id);
      load();
    } catch(e) { alert('Error al eliminar'); }
  };
  return (
    <div>
      <div style={{ background:'#fff', borderBottom:'1px solid var(--border)', padding:'14px 28px', position:'sticky', top:0, zIndex:10 }}>
        <h1 style={{ fontSize:18, fontWeight:900, color:'var(--forest)' }}>Clientes ({clientes.length})</h1>
      </div>
      <div style={{ padding:'24px 28px' }}>
        <div className="card">
          <table className="table">
            <thead><tr><th>Nombre</th><th>Email</th><th>Teléfono</th><th>Ciudad</th><th>Documento</th><th>Desde</th><th></th></tr></thead>
            <tbody>
              {clientes.map(c => (
                <tr key={c.id}>
                  <td style={{ fontWeight:700 }}>{c.nombre}</td>
                  <td style={{ fontSize:13 }}>{c.email}</td>
                  <td style={{ fontSize:13 }}>{c.telefono}</td>
                  <td style={{ fontSize:13 }}>{c.ciudad}</td>
                  <td style={{ fontSize:12, color:'var(--text-muted)' }}>{c.tipo_documento} {c.documento}</td>
                  <td style={{ fontSize:12, color:'var(--text-muted)' }}>{new Date(c.created_at).toLocaleDateString('es-CO')}</td>
                  <td><button onClick={() => eliminarCliente(c.id)} style={{ padding:'4px 10px', borderRadius:'var(--r-sm)', border:'none', background:'#fcebeb', color:'#a32d2d', fontWeight:700, fontSize:12, cursor:'pointer' }}>🗑️</button></td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
